/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class PatchComplianceReportReq {
    getFixupPrototypeFunction() { return PatchComplianceReportReq.fixupPrototype; }

    static newInstance(model: Partial<PatchComplianceReportReq>): PatchComplianceReportReq {
        let obj = Object.assign(new PatchComplianceReportReq(), model);
        PatchComplianceReportReq.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<PatchComplianceReportReq>): PatchComplianceReportReq {
        if (!model) return null;
        return PatchComplianceReportReq.newInstance(<PatchComplianceReportReq> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: PatchComplianceReportReq) {
        if (!obj) return;

        models.PatchComplianceReportReq.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: PatchComplianceReportReq): boolean {
        Object.setPrototypeOf(obj, PatchComplianceReportReq.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * span name
     */
    span: models.PatchComplianceReportSpan;

    /**
     * Specify the Azure Cloud Account ID. This can be fetched from List CloudAccounts API call.
     */
    cloud_account_id: string;

    /**
     * Specify the tenant ID. This is a unique ID and can be retrieved using the List Tenants API.
     */
    tenant_id: string;

}
